import { render, staticRenderFns } from "./PassauHeader.vue?vue&type=template&id=f06bdbc0&scoped=true&"
import script from "./PassauHeader.vue?vue&type=script&lang=js&"
export * from "./PassauHeader.vue?vue&type=script&lang=js&"
import style0 from "./PassauHeader.vue?vue&type=style&index=0&id=f06bdbc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06bdbc0",
  null
  
)

export default component.exports